import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';

export enum WireStyleState {
    // default
    NEWSWIRE_1 = 'NEWSWIRE_1',

    CUSTOM = 'CUSTOM'

}

export type WireStyleStateEnum = StyleStateEnum | WireStyleState;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const WireStyleStateEnum = {
    ...StyleStateEnum,
    ...WireStyleState
};
